// extracted by mini-css-extract-plugin
module.exports = {"button":"AddGasButton-module_button_ab901","alignButton":"AddGasButton-module_alignButton_72d22"};